import _classCallCheck from "/srv/nobackup/gitlabrunner/builds/t1_tyu7Co/0/entente-lot/lvdlr-2020-front/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";

var ChartBorder = function ChartBorder() {
  _classCallCheck(this, ChartBorder);

  this.activate = function (dygraph) {
    var originalCallback = dygraph.getFunctionOption('underlayCallback');

    var underlayCallback = function underlayCallback(ctx, area, dygraph) {
      ctx.beginPath();
      ctx.strokeStyle = 'black';
      ctx.moveTo(area.x, area.y);
      ctx.lineTo(area.w, area.y);
      ctx.moveTo(area.w, area.y);
      ctx.lineTo(area.w, area.h);
      ctx.stroke();

      if (originalCallback) {
        originalCallback.call(this, ctx, area, dygraph);
      }
    };

    dygraph.updateOptions({
      underlayCallback: underlayCallback
    }, true);
    return {};
  };
};

export { ChartBorder as default };

ChartBorder.toString = function () {
  return 'ChartBorder Plugin';
};